import { css } from '@bts-web/utils-style-engine';

export const SunIcon = ({
  active,
  ariaLabel,
  onClick,
}: {
  active: boolean;
  ariaLabel: string;
  onClick?: () => void;
}) => (
  <span
    className={css({
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: 32,
      height: 32,
      cursor: onClick ? 'pointer' : undefined,
      color: active ? 'brand.fill_primary' : 'neutrals.text_secondary',
    })}
    data-element="icon"
    aria-label={ariaLabel}
    onClick={onClick}
  >
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      {active && (
        <path
          d="M0 16C0 7.16344 7.16344 0 16 0C24.8366 0 32 7.16344 32 16C32 24.8366 24.8366 32 16 32C7.16344 32 0 24.8366 0 16Z"
          fill="currentColor"
        />
      )}
      <path
        d="M16 8C16.2761 8 16.5 8.22386 16.5 8.5V9.5C16.5 9.77614 16.2761 10 16 10C15.7239 10 15.5 9.77614 15.5 9.5V8.5C15.5 8.22386 15.7239 8 16 8ZM20 16C20 18.2091 18.2091 20 16 20C13.7909 20 12 18.2091 12 16C12 13.7909 13.7909 12 16 12C18.2091 12 20 13.7909 20 16ZM23.5 16.5C23.7761 16.5 24 16.2761 24 16C24 15.7239 23.7761 15.5 23.5 15.5H22.5C22.2239 15.5 22 15.7239 22 16C22 16.2761 22.2239 16.5 22.5 16.5H23.5ZM16 22C16.2761 22 16.5 22.2239 16.5 22.5V23.5C16.5 23.7761 16.2761 24 16 24C15.7239 24 15.5 23.7761 15.5 23.5V22.5C15.5 22.2239 15.7239 22 16 22ZM9.5 16.5C9.77614 16.5 10 16.2761 10 16C10 15.7239 9.77614 15.5 9.5 15.5H8.46289C8.18675 15.5 7.96289 15.7239 7.96289 16C7.96289 16.2761 8.18675 16.5 8.46289 16.5H9.5ZM10.1464 10.1464C10.3417 9.95118 10.6583 9.95118 10.8536 10.1464L11.8536 11.1464C12.0488 11.3417 12.0488 11.6583 11.8536 11.8536C11.6583 12.0488 11.3417 12.0488 11.1464 11.8536L10.1464 10.8536C9.95118 10.6583 9.95118 10.3417 10.1464 10.1464ZM10.8536 21.8536C10.6583 22.0488 10.3417 22.0488 10.1464 21.8536C9.95118 21.6583 9.95118 21.3417 10.1464 21.1464L11.1464 20.1464C11.3417 19.9512 11.6583 19.9512 11.8536 20.1464C12.0488 20.3417 12.0488 20.6583 11.8536 20.8536L10.8536 21.8536ZM21.8536 10.1464C21.6583 9.95118 21.3417 9.95118 21.1464 10.1464L20.1464 11.1464C19.9512 11.3417 19.9512 11.6583 20.1464 11.8536C20.3417 12.0488 20.6583 12.0488 20.8536 11.8536L21.8536 10.8536C22.0488 10.6583 22.0488 10.3417 21.8536 10.1464ZM21.1464 21.8536C21.3417 22.0488 21.6583 22.0488 21.8536 21.8536C22.0488 21.6583 22.0488 21.3417 21.8536 21.1464L20.8536 20.1464C20.6583 19.9512 20.3417 19.9512 20.1464 20.1464C19.9512 20.3417 19.9512 20.6583 20.1464 20.8536L21.1464 21.8536Z"
        fill={active ? 'white' : 'currentColor'}
      />
    </svg>
  </span>
);
